import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch book same day cleaning list data
export const getCustomerRegisterList = createAsyncThunk(
  "customerRegisterList/getCustomerRegisterList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/register`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const customerRegisterSlice = createSlice({
  name: "customerRegisterList",
  initialState: {
    loading: false,
    customerRegisterData: null,
    error: null,
  },
  reducers: {
    ResetRegisterState: (state) => {
      state.loading = false;
      state.customerRegisterData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerRegisterList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerRegisterList.fulfilled, (state, action) => {
        state.loading = false;
        state.customerRegisterData = action.payload;
      })
      .addCase(getCustomerRegisterList.rejected, (state, action) => {
        state.loading = false;
        state.customerRegisterData = action.payload;
        state.error = action.payload;
      });
  },
});

export const { ResetRegisterState } = customerRegisterSlice.actions;
export default customerRegisterSlice.reducer;
